/* ============================================================================
 * cabinet-preview-url.js — build the colorized-preview URL for a cart line.
 *
 * The preview is rendered ON DEMAND by opcabinets.com from the URL itself:
 *
 *   https://opcabinets.com/api/v1/cabinet-preview?src=<photo>&hex=%23223344&w=600
 *
 * Nothing is uploaded and nothing is stored, which is what lets an emailed
 * confirmation or a printed invoice show the cabinet: those surfaces can't run
 * JavaScript, so they need a plain <img src> that resolves on its own.
 *
 * DETERMINISM IS THE WHOLE POINT. Shopify treats line item properties as part
 * of a line's identity: two cabinets whose "Preview" values differ will NOT
 * merge into one ×2 line. So the same cabinet in the same color must produce a
 * byte-identical URL every time, from every caller. That is why canonical()
 * strips Shopify's cache-busting ?v= and its _300x-style size suffixes before
 * the URL is built — those vary between the product page and /cart.js for the
 * very same photo, and would otherwise split a line in two.
 *
 * Every caller MUST go through this file. Building the URL by hand anywhere
 * else reintroduces exactly that bug.
 * ==========================================================================*/
window.RTACabinetPreview = (function () {
  'use strict';

  var BASE = window.RTA_PREVIEW_BASE || 'https://opcabinets.com/api/v1/cabinet-preview';
  var WIDTH = window.RTA_PREVIEW_WIDTH || 600;

  /** Same photo, one spelling: drop ?v=… and any _WxH / _600x size suffix. */
  function canonical(src) {
    if (!src) return '';
    var u = String(src).split('?')[0].split('#')[0];
    if (u.indexOf('//') === 0) u = 'https:' + u;          // protocol-relative
    return u.replace(
      /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.[a-z]+$)/i,
      ''
    );
  }

  /** "Naval Blue SW 6244" → "#1f3148", via the palette already on the page. */
  function hexFor(label) {
    var list = (window.SW_COLORS || []).concat(window.RTA_STANDARD_FINISHES || []);
    if (!label) return null;
    for (var i = 0; i < list.length; i++) {
      if ((list[i].code && label.indexOf(list[i].code) !== -1) || label.indexOf(list[i].name) !== -1) {
        return list[i].hex;
      }
    }
    return null;                                          // unknown: no preview
  }

  /**
   * @param {string} photoSrc   the cabinet photo (product page or /cart.js item.image)
   * @param {string} colorLabel the "Front color" property, e.g. "Naval Blue SW 6244"
   * @param {string} [boxLabel] the "Box" property: "Premium Box" (default) or "Standard Box"
   * @returns {string} preview URL, or '' when there's nothing to render
   */
  function url(photoSrc, colorLabel, boxLabel) {
    var photo = canonical(photoSrc);
    var hex = hexFor(colorLabel);
    if (!photo || !hex) return '';                        // standard finish etc.
    // Premium Box is the default and keeps the original URL shape; only the
    // Standard Box adds a parameter (the box as photographed).
    return BASE +
      '?src=' + encodeURIComponent(photo) +
      '&hex=' + encodeURIComponent(hex) +
      '&w=' + WIDTH +
      (boxLabel === 'Standard Box' ? '&box=standard' : '');
  }

  return { url: url, canonical: canonical, hexFor: hexFor };
})();
